export const config = Object.freeze({
	databaseConfig: {
		name: 'catalog.product-form',
	},
	templateName: 'bx-form',
	templatePanelButtons: 'bx-panel-buttons',
	templatePanelCompilation: 'bx-panel-compilation',
	templateRowName: 'bx-form-row',
	templateFieldInlineSelector: 'bx-field-inline-selector',
	templateFieldPrice: 'bx-field-price',
	templateFieldResultSum: 'bx-field-result-sum',
	templateFieldQuantity: 'bx-field-quantity',
	templateFieldDiscount: 'bx-field-discount',
	templateFieldTax: 'bx-field-tax',
	templateFieldBrand: 'bx-field-brand',
	templateSummaryTotal: 'bx-summary-total',
	moduleId: 'catalog',
});
